import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { CheckCircle, Circle } from 'lucide-react';

const Status = () => {
  const [services, setServices] = useState([
    { name: 'Website', status: 'operational', uptime: '99.9%' },
    { name: 'Payment Processing', status: 'operational', uptime: '99.8%' },
    { name: 'Product Delivery', status: 'operational', uptime: '99.9%' },
    { name: 'API Services', status: 'operational', uptime: '99.7%' },
    { name: 'Customer Support', status: 'operational', uptime: '100%' },
  ]);

  const getStatusColor = (status) => {
    switch (status) {
      case 'operational':
        return 'text-green-400';
      case 'degraded':
        return 'text-yellow-400';
      case 'down':
        return 'text-red-400';
      default:
        return 'text-gray-400';
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'operational':
        return <Badge className="bg-green-600/20 text-green-400 border-green-500/30">Operational</Badge>;
      case 'degraded':
        return <Badge className="bg-yellow-600/20 text-yellow-400 border-yellow-500/30">Degraded</Badge>;
      case 'down':
        return <Badge className="bg-red-600/20 text-red-400 border-red-500/30">Down</Badge>;
      default:
        return <Badge className="bg-gray-600/20 text-gray-400 border-gray-500/30">Unknown</Badge>;
    }
  };

  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <div className="pt-24 px-4 sm:px-6 lg:px-8 pb-20">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">System Status</h1>
          <p className="text-gray-400 text-lg mb-8">Real-time status of all wallers.gg services</p>

          {/* Overall Status */}
          <Card className="bg-gradient-to-br from-green-900/20 to-green-800/20 border-green-500/30 mb-8">
            <CardContent className="p-6">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <CheckCircle className="text-green-400 mr-4" size={32} />
                  <div>
                    <h2 className="text-2xl font-bold text-white">All Systems Operational</h2>
                    <p className="text-green-400">All services are running smoothly</p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-sm text-gray-400">Last updated</p>
                  <p className="text-white font-semibold">{new Date().toLocaleString()}</p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Services List */}
          <div className="space-y-4">
            {services.map((service, index) => (
              <Card key={index} className="bg-gradient-to-br from-gray-900/50 to-gray-800/50 border-white/10">
                <CardContent className="p-6">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center flex-1">
                      <CheckCircle className={`${getStatusColor(service.status)} mr-4`} size={24} />
                      <div className="flex-1">
                        <h3 className="text-xl font-bold text-white">{service.name}</h3>
                      </div>
                    </div>
                    <div className="flex items-center space-x-4">
                      <div className="text-right mr-4">
                        <p className="text-sm text-gray-400">Uptime</p>
                        <p className="text-white font-semibold">{service.uptime}</p>
                      </div>
                      {getStatusBadge(service.status)}
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Uptime Information */}
          <Card className="bg-gradient-to-br from-purple-900/20 to-blue-900/20 border-white/10 mt-8">
            <CardContent className="p-6">
              <h3 className="text-xl font-bold text-white mb-4">Uptime Information</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                  <p className="text-gray-400 text-sm mb-1">Last 24 Hours</p>
                  <p className="text-2xl font-bold text-white">100%</p>
                </div>
                <div>
                  <p className="text-gray-400 text-sm mb-1">Last 7 Days</p>
                  <p className="text-2xl font-bold text-white">99.9%</p>
                </div>
                <div>
                  <p className="text-gray-400 text-sm mb-1">Last 30 Days</p>
                  <p className="text-2xl font-bold text-white">99.8%</p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Status;